import { useMutation } from "@tanstack/react-query";
import { updatePendingTasksInSchedule } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { PatchScheduleTask } from "@coworker/apprestructured/src/task-management/types/Task";

export const useUpdatePendingTasksInSchedule = () => {
  return useMutation({
    mutationFn: ({
      scheduleId,
      patchScheduleTask,
    }: {
      scheduleId: string;
      patchScheduleTask: PatchScheduleTask;
    }) => updatePendingTasksInSchedule(scheduleId, patchScheduleTask),
  });
};
